import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const DEFAULT_SETTINGS = {
  counterAnimationEnabled: true,
} as const;

interface SettingsState {
  counterAnimationEnabled: boolean;
  setCounterAnimationEnabled: (enabled: boolean) => void;
  resetToDefaults: () => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      counterAnimationEnabled: DEFAULT_SETTINGS.counterAnimationEnabled,
      setCounterAnimationEnabled: (enabled) =>
        set({
          counterAnimationEnabled: enabled,
        }),
      resetToDefaults: () =>
        set({
          counterAnimationEnabled: DEFAULT_SETTINGS.counterAnimationEnabled,
        }),
    }),
    {
      name: 'smartcity-dashboard-settings',
      partialize: (state) => ({
        counterAnimationEnabled: state.counterAnimationEnabled,
      }),
    }
  )
);
